// MUI
import Box from "@mui/material/Box";

// COMPONENTS
import { BulkActionBtn, BulkDiv } from "./listStyle";

// INTERFACES
import { IFdListHeaderAction } from "../../dataProvider/interfaces/IEvent";

// CUSTOM INTERFACES
interface IFdListHeadersProps {
  actions?: Array<IFdListHeaderAction>;
  enable?: Boolean; // Whether or not all buttons should be enabled or disabled (typically depends on items being selected in the list or not)
  removeBulkAction?: string;
}

const FdListHeaders = (props: IFdListHeadersProps) => {
  const { actions = [],  removeBulkAction } = props;

  const renderActionButtons = (position: "LEFT" | "RIGHT") => {
    return actions.map((el: IFdListHeaderAction) => {
      if (removeBulkAction?.includes(el.key)) return null; //  if there is any permission to access buttons
      if (el.position !== position) return null;
      return (
        <BulkActionBtn
          key={el.key}
          className={position === "RIGHT" ? "right" : undefined}
          startIcon={el.startIcon}
          onClick={() => el.callback(el)}
          variant="text"
          // disabled={!Boolean(el?.forceEnable) && !Boolean(enable)}
          disabled={!Boolean(el.isEnabled)}
        >
          {el.label}
        </BulkActionBtn>
      );
    });
  };

  return (
    <BulkDiv>
      {/* left buttons */}
      <Box flexGrow={1} textAlign="left">
        {renderActionButtons("LEFT")}
      </Box>
      {/* right buttons */}
      <Box>{renderActionButtons("RIGHT")}</Box>
    </BulkDiv>
  );
};

export default FdListHeaders;